import React from 'react';
import s from './AuthPageLayout.module.css';
interface AuthPageLayoutProps {
    children: React.ReactNode;
}

const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({ children }) => {
    return (
        <div className={s.container}>
            <div className={s.authpage_left}>
                <div className={s.shape_yellow}></div>
                <div className={s.shape_pink}></div>
                <div className={s.logo}>SimpleeCreate</div>
                <div className={s.tagline}>
                    Your content-
                    <br />
                    Simplified
                </div>
            </div>
            <div className={s.authpage_right}>{children}</div>
        </div>
    );
};

export default AuthPageLayout;
